import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './CategoryListItem.css';

const cx = classNames.bind(styles);

export default function CategoryListItem({categoryName, selected, onClick}) {
  const classes = cx({
    categoryListItem: true,
    selected
  });

  const displayName = typeof categoryName === 'string' ? categoryName : '';

  return (
    <li className={classes} onClick={onClick}>
      <p className={styles.categoryListItemText}>
        {displayName}
      </p>
    </li>
  );
}

CategoryListItem.propTypes = {
  categoryName: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};
